import "./App.css";
import { ToastContainer } from "react-toastify";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.min.js";
import "../node_modules/react-toastify/dist/ReactToastify.css";
import "./global.css";
import { ConfigProvider } from "antd";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { AUTH_TOKEN, GOOGLE_CLIENT_ID, USER_SIGN_UP_DETAIL } from "./constants";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSignUpUserDetail, setUser } from "./redux/slice/auth/authSlice";
import jwt_decode from "jwt-decode";
import { fetchTeacherData } from "./redux/slice/teacherData/teacherDataThunk.js";
import router from "./routes";
import { RouterProvider } from "react-router-dom";
import WhatsAppButton from "./components/whats-app-chat-button/index.jsx";

function App() {
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.auth.user);

  useEffect(() => {
    const token = localStorage.getItem(AUTH_TOKEN);
    const userSignUpDetail = localStorage.getItem(USER_SIGN_UP_DETAIL);
    if (userSignUpDetail) {
      let parse = JSON.parse(userSignUpDetail);
      dispatch(setSignUpUserDetail(parse));
    }
    if (token) {
      dispatch(setUser(jwt_decode(token)));
    } else dispatch(setUser(null));
  }, [dispatch]);

  useEffect(() => {
    if (currentUser?.role === "teacher") {
      dispatch(fetchTeacherData(currentUser));
    }
  }, [currentUser, dispatch]);

  return (
    <>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: "#01344F",
              colorBgContainer: "transparent",
            },
          }}
        >
          <RouterProvider router={router} />
          <WhatsAppButton />
        </ConfigProvider>
      </GoogleOAuthProvider>
      <ToastContainer
        style={{ width: "400px" }}
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </>
  );
}

export default App;
